// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"6bc32932","95":"a7b59e15","453":"c3a8e4d3"}[chunkId] + ".chunk.js";
};